<template>
  <div class="description">
    <h3 class="description__title" v-if="title" data-aos="fade" data-aos-delay="125">
      {{ title }}
    </h3>

    <div class="description__content" ref="content" data-aos="fade" data-aos-delay="150">
      <div class="user-text" v-html="content"></div>
    </div>

    <div class="description__action" data-aos="fade" data-aos-delay="200">
      <button
          type="button"
          class="description__toggle"
          @click="toggle">
        {{ toggleText }}
      </button>
    </div>

  </div>
</template>

<script>
import { isMob } from '@/assets/js/breakpoints';
import { debounce } from 'throttle-debounce';

export default {
  name: 'Description',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      state: false,
      timeline: null,
      animate: false,

      debouncedResizeHandler: null,
    };
  },
  computed: {
    toggleText() {
      return this.state ? 'Свернуть описание' : 'Показать полностью';
    },
    title() {
      return this.data.title;
    },
    content() {
      return this.data.content;
    },
  },
  methods: {
    toggle() {
      if (this.state) {
        this.animation('reverse');
      } else {
        this.animation('play');
      }
    },
    animation(direction) {
      if (this.animate) return;

      const { content } = this.$refs;

      const isMobile = isMob();
      const heightValue = isMobile ? '6.75rem' : '5.5rem';

      if (direction === 'play') {
        this.$gsap.fromTo(
          content,
          {
            minHeight: heightValue,
            height: heightValue,
          },
          {
            minHeight: 'auto',
            height: 'auto',
            duration: '0.6',
            ease: 'power1.out',
            onStart: () => {
              this.animate = true;
            },
            onComplete: () => {
              this.state = true;
              this.animate = false;
            },
          },
        );
      } else {
        this.$gsap.to(
          content,
          {
            minHeight: heightValue,
            height: heightValue,
            duration: '0.6',
            ease: 'power1.out',
            onStart: () => {
              this.animate = true;
            },
            onComplete: () => {
              this.state = false;
              this.animate = false;
            },
          },
        );
      }
    },
    heightUpdate() {
      this.animation();
    },
  },
  mounted() {
    this.debouncedResizeHandler = debounce(500, this.heightUpdate);
    window.addEventListener('resize', this.debouncedResizeHandler);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.debouncedResizeHandler);
  },
};
</script>

<style lang="scss" scoped>
@import "Description";
</style>
